import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import IncomeStatement from "./IncomeStatement";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { Typography } from "@mui/material";
import BalanceSheet from "./BalanceSheet";
import OtherDisclosures from "./OtherDisclosures";
import CashFlow from "./CashFlow";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function FinancialsTabs({ id }) {
  const [value, setValue] = React.useState(0);
  const [year, setYear] = React.useState();
  const [years, setYears] = React.useState([]);
  const [reportingPeriod, setReportingPeriod] = React.useState();
  const [reportingPeriods, setReportingPeriods] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState();
  // const [quarterlyIndexes, setQuarterlyIndexes] = React.useState([1, 2, 3, 4]);
  const quarterlyIndexes = [1, 2, 3, 4];
  const [quarterlyIndex, setQuarterlyIndex] = React.useState(1);
  // const [semiAnnualIndexes, setSemiAnnualIndexes] = React.useState([1, 2]);
  const semiAnnualIndexes = [1, 2];
  const [semiAnnualIndex, setSemiAnnualIndex] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handleReportingPeriodChange = (event) => {
    setReportingPeriod(event.target.value);
  };

  const handleQuarterlyPeriodChange = (event) => {
    setQuarterlyIndex(event.target.value);
  };

  const handleSemiAnnualPeriodChange = (event) => {
    setSemiAnnualIndex(event.target.value);
  };

  async function getQueryInfo({ id }) {
    setLoading(true);
    const docRef = doc(db, "companies", id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    setData(data);
    setYears(data["years"].sort(function(a, b){return b - a}));
    setYear(data["latest-year"]);
    setReportingPeriods(data["reporting-periods"]);
    setReportingPeriod(data["latest-period"]);
    setLoading(false);
  }

  React.useEffect(() => {
    // Fetch both the years and reporting periods for the company
    getQueryInfo({ id });
  }, [id]);

  return loading === true ? (
    <h1>Loading...</h1>
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
          <Box
            sx={{
              marginBottom: "10px",
            }}
          >
            <Typography variant="h5" align="center">
              {data["name"]}
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <FormControl fullWidth>
                  <InputLabel id="year-select-label">Year</InputLabel>
                  <Select
                    labelId="year-select-label"
                    id="year-select"
                    value={year}
                    label="Year"
                    onChange={handleYearChange}
                  >
                    {years.map((yr) => {
                      return <MenuItem key={yr} value={yr}>{yr}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <FormControl fullWidth>
                  <InputLabel id="reporting-period-select-label">
                    Reporting Period
                  </InputLabel>
                  <Select
                    labelId="reporting-period-select-label"
                    id="reporting-period-select"
                    value={reportingPeriod}
                    label="Reporting Period"
                    onChange={handleReportingPeriodChange}
                  >
                    {reportingPeriods.map((rp) => {
                      return <MenuItem value={rp} key={rp}>{rp}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {reportingPeriod === "Quarterly" ? (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <FormControl fullWidth>
                    <InputLabel id="quarterly-reporting-period-select-label">
                      Quarterly Period
                    </InputLabel>
                    <Select
                      labelId="quarterly-reporting-period-select-label"
                      id="quarterly-reporting-period-select"
                      value={quarterlyIndex}
                      label="Quarterly Period"
                      onChange={handleQuarterlyPeriodChange}
                    >
                      {quarterlyIndexes.map((rp) => {
                        return <MenuItem value={rp}>{rp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            ) : (
              <></>
            )}

            {reportingPeriod === "Half-Year" ? (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <FormControl fullWidth>
                    <InputLabel id="semi-annual-reporting-period-select-label">
                      Semi-Annual Period
                    </InputLabel>
                    <Select
                      labelId="semi-annual-reporting-period-select-label"
                      id="semi-annual-reporting-period-select"
                      value={semiAnnualIndex}
                      label="Semi-Annual Period"
                      onChange={handleSemiAnnualPeriodChange}
                    >
                      {semiAnnualIndexes.map((rp) => {
                        return <MenuItem value={rp}>{rp}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              variant="fullWidth"
            >
              <Tab label="Income Statement" />
              <Tab label="Balance Sheet" />
              <Tab label="Cash Flow" />
              {/* <Tab label="Other Disclosures" /> */}
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <IncomeStatement
              id={id}
              year={year}
              period={reportingPeriod}
              company_name={data["name"]}
              periodIndex={
                reportingPeriod === "Half-Year"
                  ? semiAnnualIndex
                  : reportingPeriod === "Quarterly"
                  ? quarterlyIndex
                  : 0
              }
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <BalanceSheet
              id={id}
              year={year}
              period={reportingPeriod}
              company_name={data["name"]}
              periodIndex={
                reportingPeriod === "Half-Year"
                  ? semiAnnualIndex
                  : reportingPeriod === "Quarterly"
                  ? quarterlyIndex
                  : 0
              }
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <CashFlow
              id={id}
              year={year}
              period={reportingPeriod}
              company_name={data["name"]}
              periodIndex={
                reportingPeriod === "Half-Year"
                  ? semiAnnualIndex
                  : reportingPeriod === "Quarterly"
                  ? quarterlyIndex
                  : 0
              }
            />
          </TabPanel>
          {/* <TabPanel value={value} index={2}>
        <OtherDisclosures id={id} year={year} period={reportingPeriod} />
      </TabPanel> */}
        </Box>
      </Grid>
    </Grid>
  );
}
